export default __webpack_public_path__ + "static/media/940.6172d8e2.png";